<template>
  <div class="tab-instruction">
    <el-row>
      <el-button :disabled="readOnly" type="primary" @click="handleAdd('sizeItemList')">新增</el-button>
      <el-button :disabled="readOnly" type="danger" @click="handleDelete('sizeItemList')">删除</el-button>
      <el-button :disabled="readOnly" @click="handlePrintTemplate">导入模板</el-button>
      <el-button :disabled="readOnly" @click="handleComputedSize">跳码计算</el-button>
      <el-button :disabled="readOnly" type="primary" @click="handleDialogBack">调整跳码</el-button>
      <!-- <el-button>
        <upload-file :disabled="info.id" btnText="导入天猫尺寸" :upload-url="uploadUrl">导入天猫尺寸</upload-file>
      </el-button> -->
      <el-button type="primary" @click="getUpdateLog">修改记录</el-button>

    </el-row>
    <el-row style="margin-bottom: 30px;">
      <el-button :disabled="readOnly" type="primary" @click="importCraft">导入工艺</el-button>
    </el-row>
    <el-row>
      <el-col :span="8">
        <base-select
          :disabled="readOnly"
          v-model="info.pieceSize"
          label="纸样尺寸"
          placeholder="纸样尺寸"
          :options="getSelectOptions"
        ></base-select>
      </el-col>
      <el-col :span="8">
        <base-select
          :disabled="readOnly"
          v-model="info.codeSize"
          label="样衣尺寸"
          placeholder="样衣尺寸"
          :options="getSelectOptions"
        ></base-select>
      </el-col>
      <el-col :span="8">
        <base-select
          :disabled="readOnly"
          v-model="info.sizeSelected"
          label="确认尺寸"
          placeholder="确认尺寸"
          :options="getSelectOptions"
        ></base-select>
      </el-col>
      <el-col :span="8">
        <base-select
          :disabled="readOnly"
          v-model="info.codonSelected"
          label="基码"
          placeholder="基码"
          :options="getSelectOptions"
        ></base-select>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        :data="info.sizeItemList"
        style="margin-top: 10px"
        @select="handleSelectItem"
        border
        stripe
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="itemNo"
          label="序号"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.itemNo" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="usedPosition"
          label="部位"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.usedPosition" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="degreeMethod"
          label="度法"
          :min-width="250"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.degreeMethod" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="increaseOrDecrease"
          label="+/-"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.increaseOrDecrease" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="materialDescCn"
          v-for="(item, $index) in info.sizeCodeList"
          :key="`tab-description__${$index}`"
          :label="item.sizeName"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.sizeMap[item.sizeName]" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="remark"
          label="备注"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.remark" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="frontBasic"
          label="前跳"
          :min-width="100"
        >
          <!-- <template slot-scope="scope">
            <base-string
              @handleEmitValue="handleAutoSetNext(scope.row)"
              :read-only="readOnly"
              v-model="scope.row.frontBasic"
              label
            ></base-string>
          </template>-->
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="backBasic"
          label="	后跳"
          :min-width="100"
        >
          <!-- <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.backBasic" label></base-string>
          </template>-->
        </el-table-column>
      </el-table>
    </el-row>

    <multiline-dialog ref="multiline-dialog" @handleSave="handleDialogSave">
      <template v-if="dialogConfig.type === 1">
        <base-select
          @handleEmitValue="handleChangeDialogSelect"
          label="请选择导入档案"
          v-model="dialogConfig.selectValue"
          apiName="POST_TECH_RECORD_LIST"
        ></base-select>
      </template>
      <template v-if="dialogConfig.type === 2">
        <multiline-table
          :cloumns="dialogConfig.cloumns"
          :dataSource="dialogConfig.list"
          :isPagination="false"
          :tableConfig="{on: {'selection-change': handleSelectChange}, props: {}}"
        ></multiline-table>
      </template>
    </multiline-dialog>

    <multiline-dialog ref="multiline-dialog-jump" @handleSave="handleDialogSaveJunp">
      <multiline-table
        ref="multiline-table"
        :cloumns="jumpDialogConfig.cloumns"
        :dataSource="jumpDialogConfig.list"
        :isPagination="false"
      ></multiline-table>
    </multiline-dialog>


    <multiline-dialog ref="update-log-multiline-dialog" @handleSave="handleDialogSaveUpdateLog">
      <multiline-table
        @handleCurrentChange="handleSearchLog"
        :cloumns="updateLog.cloumns"
        :dataSource="updateLog.list"
        :pagination="updateLog.pagination"
        :isPagination="true"
      ></multiline-table>
    </multiline-dialog>
    <multiline-dialog size="small" ref="import-craft-multiline-dialog" @handleSave="handleDialogSaveImportCraft">
      <el-row>
        <el-row>
          <base-title title="输入需要引用的款号"
          ></base-title>
        </el-row>
      </el-row>
      <el-row>
        <el-col :span="24">
          <base-string
            label="款号："
            v-model="importCraftConfig.materialCode"
            >
            </base-string>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
            <el-checkbox-group v-model="checkList" :min="1">
              <el-checkbox label="基本信息"></el-checkbox>
              <el-checkbox label="工艺说明"></el-checkbox>
              <el-checkbox label="尺寸指示"></el-checkbox>
              <el-checkbox label="工艺图示"></el-checkbox>
            </el-checkbox-group>
        </el-col>
      </el-row>
    </multiline-dialog>
  </div>
</template>
<script>
import uploadFile from "src/components/base-control/upload-file.vue";
import {
  mixins,
  jumpSizeComputedRow,
  jumpSizeOuterComputedRow,
  formatTableHead,
  formatTableCTX,
  formatGradInfo
} from "./mixins";
import * as conf from "src/store/conf";
import BaseString from '@/components/base-control/modules/base-string.vue';

export default {
  name: "tab-description",
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixins],
  components: {
    uploadFile,
    BaseString
  },
  computed: {
    getSelectOptions() {
      if (!this.info.sizeCodeList) return [];
      return this.info.sizeCodeList
        .filter(item => {
          if (item.sizeCode == "pieceSize" || item.sizeCode == "codeSize") {
            return false;
          } else {
            return true;
          }
        })
        .map(item => ({
          code: item.sizeName,
          comment: item.sizeName
        }));
    }
  },
  methods: {
    handlePrintExcel() {},
    handleDialogSaveJunp() {
      debugger
      this.info.sizeItemList = this.jumpDialogConfig.list;
      this.$refs["multiline-dialog-jump"].handleIsShow(false);
    },
    handleDialogBack() {
      const that = this;
      this.jumpDialogConfig.list = this.$utils.JsonDeepCopy(
        this.info.sizeItemList
      );
      this.jumpDialogConfig.cloumns = [
        ...[
          {
            property: "usedPosition",
            label: "部位",
            minWidth: 100
          },
          {
            property: "degreeMethod",
            label: "度法",
            minWidth: 200
          }
        ],
        ...this.info.gradCodeList.map(item => ({
          property: item.sizeName,
          label: item.sizeName,
          minWidth: 100,
          render(h, value, row, $index) {
            return (
              <base-string v-model={row.gradMap[item.sizeName]}></base-string>
            );
          }
        })),
        ...[
          {
            property: "frontBasic",
            label: "前跳",
            minWidth: 100,
            render(h, value, row, $index) {
              return (
                <base-string
                  {...{
                    on: {
                      handleEmitValue() {
                        if (row.frontBasic) row.backBasic = row.frontBasic;
                        jumpSizeComputedRow.call(that, row);
                      }
                    }
                  }}
                  v-model={row.frontBasic}
                ></base-string>
              );
            }
          },
          {
            property: "backBasic",
            label: "后跳",
            minWidth: 100,
            render(h, value, row, $index) {
              return (
                <base-string
                  {...{
                    on: {
                      handleEmitValue() {
                        if (!row.frontBasic) return false;
                        jumpSizeComputedRow.call(that, row);
                      }
                    }
                  }}
                  v-model={row.backBasic}
                ></base-string>
              );
            }
          }
        ]
      ];
      this.jumpDialogConfig.cloumns = this.$utils.bindParams(
        this.jumpDialogConfig.cloumns,
        this
      );
      this.$refs["multiline-dialog-jump"].handleIsShow(true);
    },
    handleAutoSetNext(row) {
      row.backBasic = row.frontBasic;
    },
    handleSelectChange(selectList) {
      this.dialogConfig.selectList = selectList;
    },
    handleChangeDialogSelect(selectItem) {
      this.dialogConfig.selectId = selectItem.source.id;
    },
    handleDialogSave() {
      if (this.dialogConfig.type === 1) {
        this.POST_TECH_RECORD_ITEM_LIST()
          .then(list => {
            this.dialogConfig.list = list;
            this.dialogConfig.type = 2;
          })
          .catch(err => {});
      } else {
        const sizeMap = this.info.sizeCodeList.reduce((pre, next) => {
          pre[next.sizeName] = 0;
          return pre;
        }, {});
        const length = this.info.sizeItemList.length;
        this.info.sizeItemList = this.info.sizeItemList.concat(
          this.dialogConfig.selectList.map((item, $index) => {
            return {
              ...item,
              itemNo: (length + ($index + 1)) * 10,
              sizeMap: Object.assign({}, sizeMap)
            };
          })
        );
        this.$refs["multiline-dialog"].handleIsShow(false);
      }
    },
    POST_TECH_RECORD_ITEM_LIST() {
      return new Promise((resolve, reject) => {
        this.$apis.autoAPi
          .POST_TECH_RECORD_ITEM_LIST({
            id: this.dialogConfig.selectId
          })
          .done(res => {
            resolve(res.data);
          })
          .fail(err => {});
      });
    },
    handleComputedSize() {
      if (!this.info.codonSelected)
        return this.$message({ type: "warning", message: "请选择基码" });
      const isNumber = this.$utils.isNumber;

      // if (this.isFirstComputedSize) {
      //   this.nowInfo = this.$utils.JsonDeepCopy(this.info);
      //   this.isFirstComputedSize = false;
      // }

      // this.info.sizeItemList = this.info.sizeItemList.map((item, $index) => {
      //   return {
      //     ...item,
      //     sizeMap: { ...this.nowInfo.sizeItemList[$index].sizeMap }
      //   };
      // });
      this.info.sizeItemList.forEach(item => {
        jumpSizeOuterComputedRow.call(this, item);
        // Object.keys(item.sizeMap).forEach(sizeMapKey => {
        //   const sizeMapNum = item.sizeMap[sizeMapKey];
        //   Object.keys(item.gradMap).forEach(gradMapKey => {
        //     const gradMapNum = item.gradMap[gradMapKey];
        //     if (
        //       sizeMapKey.indexOf(gradMapKey) > -1 &&
        //       isNumber(sizeMapNum) &&
        //       isNumber(gradMapNum)
        //     ) {
        //       item.sizeMap[sizeMapKey] =
        //         Number(sizeMapNum) + Number(gradMapNum);
        //     }
        //   });
        // });
      });
    },
    handlePrintTemplate() {
      this.$refs["multiline-dialog"].handleIsShow(true);
      this.dialogConfig.selectList = [];
      this.dialogConfig.type = 1;
      this.dialogConfig.selectValue = null;
    },
    getUpdateLog() {
      const businessId = this.info.id;
      this.POST_PROTECHNICS_GETUPDATELOG({
        ...this.updateLog.pagination,
        businessId
      })
      .then(res => {
        this.$refs["update-log-multiline-dialog"].handleIsShow(true);
        this.updateLog.list = res.data.records;
        this.updateLog.pagination.total = res.data.rowsCount

      }).catch(err => {
      })
    },
    handleSearchLog() {
      const businessId = this.info.id;
      this.POST_PROTECHNICS_GETUPDATELOG({
        ...this.updateLog.pagination,
        businessId
      }).then(res => {
        this.updateLog.list = res.data.records;
        this.updateLog.pagination.total = res.data.rowsCount
      }).catch(err => {})
    },
    POST_PROTECHNICS_GETUPDATELOG(params) {
      return new Promise((resolve, reject) => {
        this.$apis.autoAPi
          .POST_PROTECHNICS_GETUPDATELOG({
            ...params,
            businessTypes: ['proTechnics', 'proTechnicsGrid']
          })
          .done(res => {
            resolve(res);
          })
          .fail(err => {});
      });
    },
    handleDialogSaveUpdateLog() {
      this.$refs["update-log-multiline-dialog"].handleIsShow(false);
    },
    importCraft() {
      this.$refs["import-craft-multiline-dialog"].handleIsShow(true);
    },
    handleDialogSaveImportCraft() {
      this.$confirm('是否要覆盖？', '确定', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if(!this.importCraftConfig.materialCode) {
          return this.$message({
            type: "error",
            message: "请填写款号"
          });
        };
        this.$apis.autoAPi.POST_PROTECHNICS_TARGET_LIST({
          materialCode: this.importCraftConfig.materialCode
        }).done(res => {
          let targetId = null;
          if(res && res.data && res.data.length) {
            targetId = res.data[0].id
          };
            this.$apis.autoAPi.POST_PROTECHNICS_CPCRAFTDETAIL({
              currentCode:this.info.materialCode,
              targetId,
              currentId: this.info.id,
              selectList: this.checkList,
              userId: this.$store.state.userInfo.id,
              userName: this.$store.state.userInfo.adminUserName
          }).done(res => {
            const {id,materialCode} = this.info
            this.cpCraftDetail({id,materialCode})
          }).fail(err =>{})
        }).fail(err => {})
      })
    },
    
    cpCraftDetail(params) {
      this.$apis.autoAPi
        .POST_TECHNICS_PRO_DETAIL_GET({
          id: params.id,
          materialCode: params.materialCode
        })
        .done(res => {
          let productDemandsList = []
          // 根据后端接口返回的数据 生成适用的数据机构=>颜色/尺码的表头和内容
          if(res.data.demandList && res.data.demandList.length) {
            let demandList = res.data.demandList.sort((a,b) => a.sizeCode - b.sizeCode)
            let demandGrpup = this.$utils.groupBy(res.data.demandList, item => item.colorCode + '/' + item.colorName) 
            productDemandsList.push([null, ...this.$utils.uniq(demandList.map(item => item.sizeName))])
            this.$utils.forIn(demandGrpup, (value, key) => {
              productDemandsList.push([key, ...value.map(item => item.originQty)])
            })
          }
          this.craftInfo = {
            ...res.data,
            originDemandsListHead: formatTableHead(productDemandsList), // 原始需求列表
            originDemandsListCtx: formatTableCTX(productDemandsList),
            productDemandsListHead: formatTableHead(
              productDemandsList
            ), // 生产需求列表
            productDemandsListCtx: formatTableCTX(productDemandsList),
            sizeItemList: formatGradInfo(
              res.data.sizeItemList,
              res.data.gradCodeList,
              res.data.sizeCodeList
            ),
            pieceList: res.data.pieceList || [],
            fabricList: res.data.fabricList || [],
            detailItemList: res.data.detailItemList || [],
            productDemandsList,
            updatedTime: this.$utils.formatTime(res.data.updatedTime)
          };
          this.$emit('updateImportCraft', this.craftInfo)
          // this.$store.dispatch('saveinfo', this.info)
          this.importCraftConfig.materialCode = null
          this.$refs["import-craft-multiline-dialog"].handleIsShow(false);
          // console.log(this.info);
        })
        .fail(err => {
        });
    },
  },
  mounted() {},
  // watch: {
  //   info: {
  //     deep: true,
  //     handler(newVal,oldVal) {
  //       this.info = newVal
  //     }
  //   }
  // },
  data() {
    return {
      craftInfo:{},
      importCraftConfig:{
        materialCode:'',
        // baseInfo: '基本信息',
        // craftDesc: '工艺说明',
        // sizeInstruction: '尺寸指示',
        // craftImg:'工艺图示'
      },
      checkList:['基本信息','工艺说明','尺寸指示','工艺图示'],
      // uploadUrl: conf.TECH_MATERIAL_IMPORT, // todo 
      nowInfo: {},
      jumpDialogConfig: {
        sourceRow: {},
        selectRow: {
          sizeItemList: []
        },
        cloumns: [],
        list: []
      },
      updateLog: {
        list:[],
        pagination: {
          pageSize: 10,
          pageNumber: 1,
          total: 0,
        },
        cloumns: [
          {
            property: "fieldName",
            label: "修改项",
            minWidth: 100
          },
          {
            property: "dataBefore",
            label: "修改前值",
            minWidth: 100
          },
          {
            property: "dataCurrent",
            label: "修改后值",
            minWidth: 100
          },
          {
            property: "createdBy",
            label: "创建人编号",
            minWidth: 100
          },
          {
            property: "createdByName",
            label: "创建人名称",
            minWidth: 100
          },
          {
            property: "createdTime",
            label: "创建时间",
            minWidth: 100
          },
        ]
      },
      isFirstComputedSize: true,
      dialogConfig: {
        type: 1,
        selectValue: null,
        selectId: null,
        selectList: [],
        cloumns: [
          {
            type: "selection",
            width: 55
          },
          {
            property: "usedPosition",
            label: "部位",
            minWidth: 200
          },
          {
            property: "degreeMethod",
            label: "度法",
            minWidth: 200
          },
          {
            property: "increaseOrDecrease",
            label: "+/-",
            minWidth: 200
          }
        ]
      },
      labelConfig: {
        readOnly: true
      },
      selectList: []
    };
  }
};
</script>

<style>
.tab-instruction .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #20a0ff !important;
}
</style>
